import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
/* eslint-disable spire/export-styles */
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

export interface PageLinkModelCustom {
    title: string;
    url: string;
    type?: string;
    id: string;
    parentId?: string;
    excludeFromNavigation?: boolean;
    children?: PageLinkModelCustom[];
}

const enum fields {
    depth = "depth",
    nodeId = "nodeId",
    leftMargin = "leftMargin",
    marginBottom = "marginBottom",
    customCSS = "customCSS",
    globalMenuMapping = "globalMenuMapping",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.depth]: number;
        [fields.nodeId]: LinkFieldValue;
        [fields.leftMargin]: number;
        [fields.marginBottom]: number;
        [fields.customCSS]: string;
        [fields.globalMenuMapping]: string;
    };
}



const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const location = getLocation(state);
    const currentPageUrl = location.pathname;
    return {
        rootPageLink: getPageLinkByNodeId(state, ownProps.fields.nodeId?.value || getCurrentPage(state).nodeId),
        displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        currentPageUrl,
    };
};

interface ListStyleProp {
    leftMargin: number;
    marginBottom: number;
}

const ListStyle = styled.ul<ListStyleProp>`
    margin-left: ${props => props.leftMargin}px;
    li {
        margin-bottom: ${props => props.marginBottom}px;
    }
`;

export interface NavigationListStyles {
    titleText?: InjectableCss;
    navigationItem?: InjectableCss;
    toggleTitle?: InjectableCss;
}
export const NavigationListStyles: NavigationListStyles = {
    toggleTitle: {
        css: css`
            color: #fff;
            font-family: 'Roboto', sans-serif;
            font-size: 16px;
            letter-spacing: 0.18px;
            line-height: 23px;
            text-transform: uppercase;
            margin-bottom: 10px;
            padding: 15px;
            background-color: #002554;
            position: relative;
            cursor: pointer;

            span {
                position: absolute;
                right: 20px;
                top: 14px;
            }

            svg {
                color: #fff;
            }

            .up-arrow {
                display: none;
            }

            &.active {
                .up-arrow {
                    display: block;
                }
                .down-arrow {
                    display: none;
                }
            }

            @media screen and (min-width: 1280px) {
                display: none;
            }

            @media screen and (min-width: 990px) and (max-width: 1280px) {
                padding: 15px 25px;

                span {
                    right: 30px;
                }
            }
        `,
    },
    titleText: {
        css: css`
            color: #C63527;
            font-family: 'Roboto', sans-serif;
            font-size: 16px;
            letter-spacing: 0.18px;
            line-height: 23px;
            text-transform: uppercase;
            margin-bottom: 10px;
            padding-top: 20px;
            padding-left: 15px;
            padding-right: 15px;
        `,
    },
    navigationItem: {
        css: css`
        border-bottom: 1px solid rgba(194,209,217,0.45);
        margin-bottom: 0;
        width: 100%;

        &.navigation-list-item {
            margin-bottom: 0;
            padding-left: 15px;
            padding-right: 15px;
        }

        .navigation-list-link {
            padding-left: 15px;
            padding-right: 15px;
        }

        .navigation-list-link,
        a {
            font-family: 'Roboto', sans-serif;
            color: #002554;
            font-size: 14px;
            letter-spacing: -0.23px;
            line-height: 35px;
            display: block;
            position: relative;

            span {
                color: #002554;
            }

            &.active {
                background-color: #F3F4F5;
                color: #333F48;
                font-weight: bold;

                @media (max-width: 991px) {
                    margin-bottom: 0;
                }

                span {
                    background-color: #F3F4F5;
                    color: #333F48;
                    font-weight: bold;
                }
                
                &:before {
                    content: '';
                    display: block;
                    background-color: #333F48;
                    width: 4px;
                    height: 100%;
                    position: absolute;
                    left: 0;
                }
            }
        }
    `,
    }
};
const styles = NavigationListStyles;

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const NavigationList = (props: Props) => {
    let myAccountMapping = "";
    const groups: string[] = [];
    const myAccountPageLinks = props?.myAccountPageLink as PageLinkModelCustom;
    // const myAccountPageLinks = props?.rootPageLink as PageLinkModelCustom;

    if (typeof props?.fields?.globalMenuMapping !== "undefined" && props?.fields?.globalMenuMapping !== "") {
        myAccountMapping = JSON.parse(props?.fields?.globalMenuMapping.replace(/\//g, ""));
    }
    Object.keys(myAccountMapping).forEach(function (group) {
        groups.push(group);
    });

    // if (!props.rootPageLink || !props.rootPageLink.children) {
    //     return null;
    // }
    if (!props.rootPageLink) {
        return null;
    }

    const [showAccMenu, setshowAccMenu] = React.useState(false);

    const customCssWrapper = {
        css: css`
            ${props.fields.customCSS};
            position: relative;
            padding-top: 0;
            top: -66px;
            background: #fff;
            box-shadow: 2px 0 4px 0 rgb(0 37 84 / 5%);

            > div {
                margin-left: 15px;
                margin-right: 15px;
            }
            
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                        top: 0;
                        margin-top: -15px;
                        margin-left: -15px;
                        margin-right: -15px;
                        `,
                        css`
                        top: 0;
                        margin-top: -15px;
                        margin-left: 0;
                        margin-right: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )
            };
            @media screen and (max-width: 767px) {
                margin-left: -15px;
                margin-right: -15px;
            }
            @media screen and (min-width: 990px) and (max-width: 1279px) {
                top: -15px;
                padding-bottom: 0;
            }
            @media screen and (max-width: 1279px) {
                .mob-hidden {
                    display: none;
                    &.active-menu {
                        display: block;
                        position: absolute;
                        z-index: 9;
                        background: #fff;
                        width: 100%;
                        left: -15px;

                        > div {
                            position: relative;
                            z-index: 9;
                            background: #fff;
                        }

                        &:after {
                            content: '';
                            display: block;
                            position: absolute;
                            z-index: 2;
                            opacity: 0.32;
                            background-color: #002554;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 8000px;
                        }
                    }
                }
            }
        }
    }
`,
    };

    const renderLink = (pageLink: PageLinkModel, currentDepth: number) => {
        if (currentDepth > props.fields.depth) {
            return;
        }

        if (
            pageLink.excludeFromNavigation ||
            (pageLink.type === "ChangeCustomerPage" && !props.displayChangeCustomerLink)
        ) {
            return;
        }

        const nextDepth = currentDepth + 1;


        return (

            <Typography as="li" key={pageLink.id} className="navigation-list-item acc" {...styles.navigationItem}>

                <Link
                    className="navigation-list-link"
                    data-test-selector={`navigationList-${pageLink.title} `}
                    href={pageLink.url}
                >
                    {pageLink.title}
                </Link>
                {pageLink.children && pageLink.children.length > 0 && (
                    <ListStyle
                        marginBottom={props.fields.marginBottom}
                        leftMargin={props.fields.leftMargin}
                        key={pageLink.id}
                    >
                        {pageLink.children.map(link => renderLink(link, nextDepth))}
                    </ListStyle>
                )}


            </Typography>
        );
    };

    const getlinkgroupIdentifier = (link: PageLinkModelCustom) => {
        let identifier = "";
        groups.forEach((group: any) => {
            const title = link.title;
            if (myAccountMapping[group].indexOf(title) !== -1) {
                identifier = group;
                return identifier;
            }
        });
        return identifier;
    };
    return (
        <StyledWrapper {...customCssWrapper}>
            <Typography as="h2" {...styles.toggleTitle} onClick={() => setshowAccMenu(!showAccMenu)} className={`${showAccMenu ? 'active' : ''} `}>
                {translate("My Account")}
                <Icon className="down-arrow" src="ChevronDown" />
                <Icon className="up-arrow" src="ChevronUp" />
            </Typography>
            <Typography as="div" className={`mob-hidden ${showAccMenu ? 'active-menu' : ''} `}>
                <Typography as="div" className="navigation-title">
                    {groups?.map(groupName => (
                        <Typography>
                            <Typography as="h3" {...styles.titleText}>
                                {translate(groupName)}
                            </Typography>
                            {getlinkgroupIdentifier(myAccountPageLinks) === groupName && (
                                <StyledWrapper key={myAccountPageLinks?.id} {...styles.navigationItem}>
                                    <Link href={myAccountPageLinks?.url} className={`navigation-list-link ${myAccountPageLinks?.url === props.currentPageUrl ? "active" : ""} `}>
                                        <Typography>
                                            {myAccountPageLinks && translate(myAccountPageLinks?.title)}
                                        </Typography>
                                    </Link>
                                    <StyledWrapper></StyledWrapper>
                                </StyledWrapper>
                            )}
                            {myAccountPageLinks?.children?.map(
                                link =>
                                    getlinkgroupIdentifier(link) === groupName && (
                                        <StyledWrapper key={link?.id} {...styles.navigationItem}>
                                            <Link href={link?.url} className={`navigation-list-link ${link?.url === props.currentPageUrl ? "active" : ""} `}>
                                                <Typography>
                                                    {translate(link?.title)}
                                                </Typography>
                                            </Link>
                                            <StyledWrapper></StyledWrapper>
                                        </StyledWrapper>
                                    ),
                            )}
                        </Typography>
                    ))}
                </Typography>
            </Typography>
        </StyledWrapper >
    )
};

const defaultCustomCss = `.navigation-list{
}

.navigation-list-item {
}

.navigation-list-link { 
}
`;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NavigationList),
    definition: {
        group: "Basic",
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.depth,
                displayName: "Depth",
                editorTemplate: "IntegerField",
                defaultValue: 2,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.nodeId,
                displayName: "Page",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
                allowUrls: item => false,
                allowCategories: item => false,
                tab: basicTab,
            },
            {
                name: fields.leftMargin,
                displayName: "Left Margin",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
                tab: basicTab,
            },
            {
                name: fields.marginBottom,
                displayName: "Margin Bottom",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    const result = cssLinter.parse(value, { silent: true });

                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line} `)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.globalMenuMapping,
                displayName: "Global Menu Group-Link Mapping",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
